module.exports = __webpack_public_path__ + "media/images/webpage/shared/spotmap/location__here-79a334c286fe5676122ecfd8e5a6c1d7.svg";